module.exports = __webpack_public_path__ + "img/media-28.98b070a1.png";